module.exports = __webpack_public_path__ + "static/index/img/baikal-501.737fc3e9.jpg";